import {
    collection,
    component, dateCollection,
    dateField,
    EntityData,
    field,
    identifier,
    LocalisableEntityData, transientCollection, transientField
} from "@fedeltapointofsale/data-client";

export class MyreportDistributionUserData extends EntityData<MyreportDistributionUserData> {
    @field userId: number;
    @field name: string;
    @field firstName: string;
    @field lastName: string;
}

export class MyreportDistributionContactData extends EntityData<MyreportDistributionContactData> {
    @field email: string;
}

export class MyreportDistributionEmployeeData extends EntityData<MyreportDistributionEmployeeData> {
    @field employeeId: number;
    @component contact: MyreportDistributionContactData;
    @component user: MyreportDistributionUserData;
}

export class MyreportDistributionData extends EntityData<MyreportDistributionData> {
    @field recuserId: number;
    @component employee: MyreportDistributionEmployeeData;
}

export class MyreportSchedulePatternData extends EntityData<MyreportSchedulePatternData> {
    public static TYPE_HOURLY = "HOURLY";
    public static TYPE_DAILY = "DAILY";
    public static TYPE_WEEKLY = "WEEKLY";
    public static TYPE_MONTHLY = "MONTHLY";
    public static NO_SPECIFIC_VALUE = "?";
    public static ALL_VALUES = "*";

    public static HOURLY_PATTERN_TYPE_MINUTES = "minutes";
    public static HOURLY_PATTERN_TYPE_HOURS = "hours";

    public static DAILY_PATTERN_TYPE_EVERY_DAY = "everyDay";
    public static DAILY_PATTERN_TYPE_EVERY_WEEK_DAY = "everyWeekday";

    public static MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF = "everyDayOf";
    public static MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF_WEEK = "everyDayOfWeek";


    isLoaded: boolean;

    @field type: string;
    @field seconds: string;
    @field minutes: string;
    @field hours: string;
    @field dayOfMonth: string;
    @field month: string;
    @field dayOfWeek: string;
    @field year: string;

    private _patternType: string;

    private _hourlyPatternValue: number;
    private _hourlyTypePatternValue: string;

    private _dailyTypePatternValue: string;
    private _dailyPatternNumberDays: number;

    private _weeklyDayOfWeek: string[];

    private _monthlyFrequencyType: string;
    private _monthlySelectedMonths: string[];
    private _monthlyDayOfMonth: number;
    private _monthlyOccurrence: string = "1";
    private _monthlyDayOfWeek: string = "1";

    @transientField get patternType(): string {
        return this._patternType;
    }

    set patternType(value: string) {
        this._patternType = value;
        this.type = value;

        if (value === MyreportSchedulePatternData.TYPE_HOURLY) {
            if (!this._hourlyTypePatternValue) {
                this._hourlyTypePatternValue = MyreportSchedulePatternData.HOURLY_PATTERN_TYPE_HOURS;
            }
        } else if (value === MyreportSchedulePatternData.TYPE_DAILY) {
            if (!this._dailyTypePatternValue) {
                this._dailyTypePatternValue = MyreportSchedulePatternData.DAILY_PATTERN_TYPE_EVERY_DAY;
            }
        } else if (value === MyreportSchedulePatternData.TYPE_MONTHLY) {
            if (!this._monthlyFrequencyType) {
                this._monthlyFrequencyType = MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF;
            }
        }

        this.setFieldValues();
    }

    @transientField get monthlyDayOfWeek(): string {
        return this._monthlyDayOfWeek;
    }

    set monthlyDayOfWeek(value: string) {
        this._monthlyDayOfWeek = value;
        this.setFieldValues();
    }

    @transientField get monthlyOccurrence(): string {
        return this._monthlyOccurrence;
    }

    set monthlyOccurrence(value: string) {
        this._monthlyOccurrence = value;
        this.setFieldValues();
    }

    @transientField get monthlyDayOfMonth(): number {
        return this._monthlyDayOfMonth;
    }

    set monthlyDayOfMonth(value: number) {
        this._monthlyDayOfMonth = value;
        this.setFieldValues();
    }

    @transientCollection() get monthlySelectedMonths(): string[] {
        return this._monthlySelectedMonths;
    }

    set monthlySelectedMonths(value: string[]) {
        this._monthlySelectedMonths = value;
        this.setFieldValues();
    }

    @transientField get monthlyFrequencyType(): string {
        return this._monthlyFrequencyType;
    }

    set monthlyFrequencyType(value: string) {
        this._monthlyFrequencyType = value;
        this.setFieldValues();
    }

    @transientCollection() get weeklyDayOfWeek(): string[] {
        return this._weeklyDayOfWeek;
    }

    set weeklyDayOfWeek(value: string[]) {
        this._weeklyDayOfWeek = value;
        this.setFieldValues();
    }

    @transientField get dailyPatternNumberDays(): number {
        return this._dailyPatternNumberDays;
    }

    set dailyPatternNumberDays(value: number) {
        this._dailyPatternNumberDays = value;
        this.setFieldValues();
    }

    @transientField get dailyTypePatternValue(): string {
        return this._dailyTypePatternValue;
    }

    set dailyTypePatternValue(value: string) {
        this._dailyTypePatternValue = value;
        this.setFieldValues();
    }

    @transientField get hourlyTypePatternValue(): string {
        return this._hourlyTypePatternValue;
    }

    set hourlyTypePatternValue(value: string) {
        this._hourlyTypePatternValue = value;
        this.setFieldValues();
    }

    @transientField get hourlyPatternValue(): number {
        return this._hourlyPatternValue;
    }

    set hourlyPatternValue(value: number) {
        this._hourlyPatternValue = value;
        this.setFieldValues();
    }

    override onLoad(): void {
        this._patternType = this.type;

        if (this.type === MyreportSchedulePatternData.TYPE_HOURLY) {
            if (this.minutes === "0") {
                this._hourlyTypePatternValue = MyreportSchedulePatternData.HOURLY_PATTERN_TYPE_HOURS;
                this._hourlyPatternValue = parseInt(this.hours.substring(this.hours.indexOf("/") + 1));
            } else {
                this._hourlyTypePatternValue = MyreportSchedulePatternData.HOURLY_PATTERN_TYPE_MINUTES;
                this._hourlyPatternValue = parseInt(this.minutes.substring(this.minutes.indexOf("/") + 1));
            }
        } else if (this.type === MyreportSchedulePatternData.TYPE_DAILY) {
            if (this.dayOfWeek === "MON-FRI") {
                this._dailyTypePatternValue = MyreportSchedulePatternData.DAILY_PATTERN_TYPE_EVERY_WEEK_DAY;
            } else {
                this._dailyTypePatternValue = MyreportSchedulePatternData.DAILY_PATTERN_TYPE_EVERY_DAY;
                this._dailyPatternNumberDays = parseInt(this.dayOfMonth.substring(2));
            }
        } else if (this.type === MyreportSchedulePatternData.TYPE_WEEKLY) {
            if (this.dayOfWeek) {
                this._weeklyDayOfWeek = this.dayOfWeek.split(",");
            }
        } else if (this.type === MyreportSchedulePatternData.TYPE_MONTHLY) {
            if (this.month) {
                this._monthlyDayOfMonth = parseInt(this.month);
            }
            if (this.dayOfMonth !== MyreportSchedulePatternData.NO_SPECIFIC_VALUE) {
                this._monthlyFrequencyType = MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF;
                this._monthlyDayOfMonth = parseInt(this.dayOfMonth);
            } else {
                this._monthlyFrequencyType = MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF_WEEK;
                if (this.dayOfWeek.charAt(1) === "L") {
                    this._monthlyOccurrence = "L";
                } else {
                    this._monthlyOccurrence = this.dayOfWeek.charAt(2);
                }
                this._monthlyDayOfWeek = this.dayOfWeek.substring(0, 1);
            }
            this._monthlySelectedMonths = this.month.split(",");
        }

        this.isLoaded = true;
    }

    setFieldValues(): void {
        const parentScheduleData: MyreportScheduleData = <MyreportScheduleData>this.ednParent;
        if (!this.isLoaded || !parentScheduleData.startTime || !parentScheduleData.startDate) {
            return;
        }
        const startHourOfDay: string = parentScheduleData.startTime.getHours() + "";
        const startMinuteOfHour = parentScheduleData.startTime.getMinutes() + "";
        const startWeekDay = parentScheduleData.startDate.getDay() + "";
        if (this.type === MyreportSchedulePatternData.TYPE_HOURLY) {
            if (this._hourlyTypePatternValue === MyreportSchedulePatternData.HOURLY_PATTERN_TYPE_HOURS) {
                this.setHourlyPattern(startHourOfDay + "/" + this.hourlyPatternValue, "0")
            } else {
                this.setHourlyPattern("*", startMinuteOfHour + "/" + this.hourlyPatternValue);
            }
        } else if (this.type === MyreportSchedulePatternData.TYPE_DAILY) {
            if (this._dailyTypePatternValue === MyreportSchedulePatternData.DAILY_PATTERN_TYPE_EVERY_WEEK_DAY) {
                this.setDailyPattern(startHourOfDay, startMinuteOfHour, "MON-FRI");
            } else {
                this.setDailyPattern(startHourOfDay, startMinuteOfHour, MyreportSchedulePatternData.NO_SPECIFIC_VALUE);
                this.dayOfMonth = "*/" + this.dailyPatternNumberDays;
            }
        } else if (this.type === MyreportSchedulePatternData.TYPE_WEEKLY) {
            const dayOfWeekPattern: string = this._weeklyDayOfWeek && this._weeklyDayOfWeek.length > 0 ? this._weeklyDayOfWeek.join(",") : startWeekDay;
            this.setWeeklyPattern(startHourOfDay, startMinuteOfHour, dayOfWeekPattern);
        } else if (this.type === MyreportSchedulePatternData.TYPE_MONTHLY) {
            this.hours = startHourOfDay
            this.minutes = startMinuteOfHour;
            this.seconds = "0";
            this.month = !this.monthlySelectedMonths || this.monthlySelectedMonths.length === 0 ? MyreportSchedulePatternData.ALL_VALUES : this.monthlySelectedMonths.join(",");
            if (this._monthlyFrequencyType === MyreportSchedulePatternData.MONTHLY_FREQUENCY_TYPE_EVERY_DAY_OF) {
                this.dayOfMonth = this.monthlyDayOfMonth + "";
                this.dayOfWeek = MyreportSchedulePatternData.NO_SPECIFIC_VALUE;
            } else {
                let weekChoice: string = this.monthlyOccurrence;
                const dayOfWeekChoice: string = this.monthlyDayOfWeek;
                if (weekChoice !== "L") {
                    weekChoice = "#" + weekChoice;
                }
                this.dayOfWeek = dayOfWeekChoice + weekChoice;
                this.dayOfMonth = MyreportSchedulePatternData.NO_SPECIFIC_VALUE;
            }
        }
    }

    setHourlyPattern(hours: string, minutes: string): void {
        this.dayOfMonth = MyreportSchedulePatternData.NO_SPECIFIC_VALUE;
        this.month = MyreportSchedulePatternData.ALL_VALUES;
        this.dayOfWeek = MyreportSchedulePatternData.ALL_VALUES;
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = "0";
    }

    setDailyPattern(hours: string, minutes: string, dayOfWeek: string): void {
        this.dayOfMonth = MyreportSchedulePatternData.NO_SPECIFIC_VALUE;
        this.month = MyreportSchedulePatternData.ALL_VALUES;
        this.dayOfWeek = dayOfWeek;
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = "0";
    }

    setWeeklyPattern(hours: string, minutes: string, dayOfWeek: string): void {
        this.seconds = "0";
        this.minutes = minutes;
        this.hours = hours;
        this.dayOfMonth = MyreportSchedulePatternData.NO_SPECIFIC_VALUE;
        this.month = MyreportSchedulePatternData.ALL_VALUES;
        this.dayOfWeek = dayOfWeek;
    }
}

export class MyreportScheduleData extends EntityData<MyreportScheduleData> {
    @identifier templateId: number;
    @field name: string;
    private _startDate: Date;
    @dateField finishDate: Date;
    private _startTime: Date;
    @dateField finishTime: Date;
    @field occurances: number;
    @field duration: number;
    @component pattern: MyreportSchedulePatternData;
    @dateCollection exceptions: Date;

    private _rangeRecurrence: boolean = false;

    @dateField get startDate(): Date {
        return this._startDate;
    }

    set startDate(value: Date) {
        this._startDate = value;
        this.pattern.setFieldValues();
    }

    @dateField get startTime(): Date {
        return this._startTime;
    }

    set startTime(value: Date) {
        this._startTime = value;
        this.pattern.setFieldValues();
    }

    @transientField get rangeRecurrence(): boolean {
        return this._rangeRecurrence;
    }

    set rangeRecurrence(value: boolean) {
        this._rangeRecurrence = value;

        if (!value) {
            this.finishDate = undefined;
            this.finishTime = undefined;
        }
    }

    override onLoad(): void {
        this.pattern.onLoad();

        this._rangeRecurrence = this.finishDate != undefined;
    }
}

export class MyreportData extends LocalisableEntityData<MyreportData> {
    @identifier myreportId: number;
    @field myreportName: string;
    @field reportUIId: string;
    @field report: string;
    @field jobName: string;
    @field publicReport: boolean = true;
    @dateField lastUpdated: Date;
    @dateField lastPublishTime: Date;
    @dateField nextPublishTime: Date;
    @field emailFlag: boolean;
    @field selectedDataFlag: boolean;
    @field printFlag: boolean;
    @field myDefault: boolean;
    @field emailFlagForNoPages: boolean;
    @field parametersAsString: string;

    @component scheduleTemplateData: MyreportScheduleData;
    @collection(MyreportDistributionData) distributionList: MyreportDistributionData[];

    public static uuidToResourceName(uuid: string): string {
        // strip postfix to handle custom reports
        let s = uuid.indexOf("_") > 0 ? uuid.substring(0, uuid.indexOf("_")) : uuid;
        if (s.endsWith("UI")) {
            s = s.substr(0, s.length - "UI".length);
        }
        s = s.replace(/\.?([A-Z])/g, function (x, y) {
            return "-" + y.toLowerCase()
        }).replace(/^-/, "")
        return s;
    }

    public static resourceNameToUuid(resourceName: string): string {
        const uuid: string = resourceName.replace(/-([a-z])/g, function (g) {
            return g[1].toUpperCase();
        });
        return uuid.substring(0, 1).toUpperCase() + uuid.substring(1) + "UI";
    }

    override onLoad(): void {
        this.scheduleTemplateData.onLoad();
    }
}
